import { render, staticRenderFns } from "./ApproveButton.vue?vue&type=template&id=1f6e62c5&scoped=true&"
import script from "./ApproveButton.vue?vue&type=script&lang=js&"
export * from "./ApproveButton.vue?vue&type=script&lang=js&"
import style0 from "./ApproveButton.vue?vue&type=style&index=0&id=1f6e62c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e62c5",
  null
  
)

export default component.exports